import React, { useEffect, useState } from 'react'
import CustomInput from './CustomInput'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Svg from '../../../common/Svg';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFields } from '../../../store/actions/surveyFieldDataAction';
import { getRequiredText } from '../../../utils/validationTranslations';

const Section = ({ questions, nextSection, previousSection, sectionId, handleSubmitSurvey, name, desc, startCount, ss_id, survey_id, submitResponse, setCurrentSection, setCurrentSectionWidth, progressBar, buttonHeading, buttonNext, buttonBack, surveyLangName }) => {
    //State
    const dispatch = useDispatch()
    const { surveyFieldsData } = useSelector((state) => state.surveyFieldData)
    const [fielledRatio, setFielledRatio] = useState(0)

    //Yup - Schema
    const requiredText = getRequiredText(surveyLangName);
    let schemaShape = {}

    questions?.forEach((que) => {
        const isRequired = que.su_is_required === 1
        const key = que.su_question_id

        if (isRequired) {
            schemaShape[key] = Yup.string().required(requiredText)
        } else {
            schemaShape[key] = Yup.string()
        }
    })

    //Formik
    let initialValues = {}
    let initialTouched = {}
    let initialError = {}

    questions?.forEach((question) => {
        const key = question.su_question_id
        initialValues[key] = ''
        initialTouched[key] = false
        initialError[key] = ''
    })

    const Schema = Yup.object().shape(schemaShape);

    const formik = useFormik({
        initialValues: initialValues,
        initialErrors: initialError,
        initialTouched: initialTouched,
        validationSchema: Schema,

        onSubmit: (values) => {
            if (nextSection) {
                dispatch(setSectionFields(sectionId, values))
                setCurrentSection(nextSection)
            } else {
                handleSubmitSurvey()
            }
        },
    })

    const { values, handleSubmit, setValues } = formik


    //Functionalities
    const handlePageChangeToPrev = (e, prevSection) => {
        e.preventDefault()
        setCurrentSection(prevSection)
    }


    //Effects
    useEffect(() => {
        if (values) {
            dispatch(setSectionFields(sectionId, values))
        }
    }, [values])

    useEffect(() => {
        window.scrollTo({ top: 0 })
        progressBar?.current.scrollIntoView();

        if (surveyFieldsData && surveyFieldsData[sectionId]) {
            setValues(surveyFieldsData[sectionId])
        }
    }, [sectionId])

    useEffect(() => {
        if (values && questions) {
            const totalQuestion = questions.length

            let totalAnsweredQuestion = 0
            Object.keys(values)?.forEach((que) => {
                if (values[que]) {
                    totalAnsweredQuestion += 1
                }
            })

            const fieldedQueRatio = (totalAnsweredQuestion / totalQuestion)

            setFielledRatio(fieldedQueRatio)
            setCurrentSectionWidth(fieldedQueRatio)
        }
    }, [values, questions])


    return (
        <>
            <div className="container">
                <div className='header mt-3'>
                    <h1>{name ?? ''}</h1>
                    <p>{desc ?? ''}</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="question-list">
                        {
                            questions?.map((question, index) => {
                                return (
                                    <div key={index} id={`qusDiv_${question.su_question_id}`}>
                                        <CustomInput
                                            fieldData={question}
                                            formikData={formik}
                                            submitResponseCallback={submitResponse}
                                            numbering={startCount + index}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={previousSection ? `d-flex justify-content-between btn-wrapper text-end` : `btn-wrapper text-end`}>

                        {previousSection && <button className='btn btn-link btn-icon' onClick={(e) => { handlePageChangeToPrev(e, previousSection) }}>
                            <Svg name="back-button-icon" /> {buttonBack}
                        </button>}
                        {nextSection ? <button className={`btn btn-primary btn-icon ms-auto ${fielledRatio !== 1 ? ' btn-disabled' : ''}`} disabled={fielledRatio !== 1} type='submit'>
                            {buttonNext} <Svg name="button-icon" />
                        </button> : <button className={`btn btn-primary btn-icon ms-auto ${fielledRatio !== 1 ? 'btn-disabled' : ''}`} disabled={fielledRatio !== 1} type='submit'>
                            {buttonHeading} <Svg name="button-icon" />
                        </button>}
                    </div>
                </form >
            </div >
        </>
    )
}

export default Section